const Footer = () => {
  return (
    <footer className="footer-container">
      <hr />
      <div className="mx-64">
        <div className="footer">
          <ul className="flex list-none text-lg font-medium text-gray-500">
            <li className="p-3 m-3">About us</li>
            <li className="p-3 m-3">Company History</li>
            <li className="p-3 m-3">Our Team</li>
            <li className="p-3 m-3">Our Vision</li>
            <li className="p-3 m-3">Press Release</li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
